import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';

import Loading from '~/components/Loading';
import history from '~/services/history';

import useWhatsappSupport from './hooks/useWhatsappSupport';
import QueuePanel from './QueuePanel';
import ChatPanel from './ChatPanel';
import DetailsPanel from './DetailsPanel';
import EmptyState from './EmptyState';

function WhatsappSupport() {
  const support = useWhatsappSupport();
  const [showDetails, setShowDetails] = useState(false);
  const [mobileView, setMobileView] = useState('queue'); // 'queue' | 'chat' | 'details'

  useEffect(() => {
    setShowDetails(false);
  }, [support.activeTicket?.id]);

  useEffect(() => {
    document.title = 'Atendimento WhatsApp | Viddy';
  }, []);

  // Quando seleciona ticket no mobile, vai para o chat
  const handleMobilePickUp = async id => {
    await support.pickUp(id);
    setMobileView('chat');
  };

  const handleMobileSelectTicket = async ticket => {
    await support.selectTicket(ticket);
    setMobileView('chat');
  };

  if (support.loadingQueue) {
    return (
      <div className="page-content">
        <Container className="container new-layout wide">
          <Loading />
        </Container>
      </div>
    );
  }

  const chatColSize = showDetails ? 6 : 9;
  const panelHeight = 'calc(100vh - 160px)';

  return (
    <div className="page-content pb-0">
      <Container className="container new-layout wide">
        {/* =================== MOBILE =================== */}
        <div className="d-lg-none" style={{ height: panelHeight }}>
          {mobileView === 'queue' && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <button
                type="button"
                onClick={() => history.push('/suporte')}
                style={{
                  padding: '8px 14px',
                  fontSize: '12px',
                  background: '#f8f8f6',
                  border: 'none',
                  borderBottom: '0.5px solid #dee2e6',
                  textAlign: 'left',
                  cursor: 'pointer',
                  color: '#0C447C',
                  flexShrink: 0,
                }}
              >
                ← Voltar para subscribers
              </button>
            </div>
          )}
          {/* Mobile: Queue */}
          {mobileView === 'queue' && (
            <QueuePanel
              queue={support.queue}
              myTickets={support.myTickets}
              activeTicket={support.activeTicket}
              recentTickets={support.recentTickets}
              onPickUp={handleMobilePickUp}
              onSelectTicket={handleMobileSelectTicket}
              onSelectRecent={support.selectTicket}
              onChangePeriod={support.changeRecentPeriod}
            />
          )}

          {/* Mobile: Chat */}
          {mobileView === 'chat' && support.activeTicket && (
            <div
              style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* Botão voltar */}
              <button
                type="button"
                onClick={() => setMobileView('queue')}
                style={{
                  padding: '8px 14px',
                  fontSize: '12px',
                  background: '#f8f8f6',
                  border: 'none',
                  borderBottom: '0.5px solid #dee2e6',
                  textAlign: 'left',
                  cursor: 'pointer',
                  color: '#0C447C',
                  flexShrink: 0,
                }}
              >
                ← Voltar para atendimentos
              </button>
              <div style={{ flex: 1, minHeight: 0 }}>
                <ChatPanel
                  ticket={support.activeTicket}
                  messages={support.messages}
                  loadingMessages={support.loadingMessages}
                  quickReplies={support.quickReplies}
                  currentUser={support.currentUser}
                  onSendMessage={support.sendMessage}
                  onResolveQuickReply={support.resolveQuickReply}
                  onTransfer={support.transferTicket}
                  onClose={id => {
                    support.closeTicket(id);
                    setMobileView('queue');
                  }}
                  showDetails={false}
                  onToggleDetails={() => setMobileView('details')}
                  onSendAttachment={support.sendAttachment}
                  onReopen={support.reopenTicket}
                />
              </div>
            </div>
          )}

          {/* Mobile: Details */}
          {mobileView === 'details' && support.activeTicket && (
            <div
              style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <button
                type="button"
                onClick={() => setMobileView('chat')}
                style={{
                  padding: '8px 14px',
                  fontSize: '12px',
                  background: '#f8f8f6',
                  border: 'none',
                  borderBottom: '0.5px solid #dee2e6',
                  textAlign: 'left',
                  cursor: 'pointer',
                  color: '#0C447C',
                  flexShrink: 0,
                }}
              >
                ← Voltar para o chat
              </button>
              <div style={{ flex: 1, minHeight: 0 }}>
                <DetailsPanel ticket={support.activeTicket} />
              </div>
            </div>
          )}

          {/* Mobile: Empty */}
          {mobileView === 'chat' && !support.activeTicket && (
            <EmptyState
              queueCount={support.queue.length}
              ticketsCount={support.myTickets.length}
            />
          )}
        </div>

        {/* =================== DESKTOP =================== */}
        <Row className="w-100 mx-0 d-none d-lg-flex">
          <Col lg={3} className="px-0 pr-lg-2" style={{ height: panelHeight }}>
            <QueuePanel
              queue={support.queue}
              myTickets={support.myTickets}
              activeTicket={support.activeTicket}
              recentTickets={support.recentTickets}
              onPickUp={support.pickUp}
              onSelectTicket={support.selectTicket}
              onSelectRecent={support.selectTicket}
              onChangePeriod={support.changeRecentPeriod}
            />
          </Col>

          <Col
            lg={chatColSize}
            className="px-0 px-lg-2"
            style={{ height: panelHeight }}
          >
            {support.activeTicket ? (
              <ChatPanel
                ticket={support.activeTicket}
                messages={support.messages}
                loadingMessages={support.loadingMessages}
                quickReplies={support.quickReplies}
                currentUser={support.currentUser}
                onSendMessage={support.sendMessage}
                onResolveQuickReply={support.resolveQuickReply}
                onTransfer={support.transferTicket}
                onClose={support.closeTicket}
                showDetails={showDetails}
                onToggleDetails={() => setShowDetails(prev => !prev)}
                onSendAttachment={support.sendAttachment}
                onReopen={support.reopenTicket}
              />
            ) : (
              <EmptyState
                queueCount={support.queue.length}
                ticketsCount={support.myTickets.length}
              />
            )}
          </Col>

          {showDetails && support.activeTicket && (
            <Col
              lg={3}
              className="px-0 pl-lg-2"
              style={{ height: panelHeight }}
            >
              <DetailsPanel ticket={support.activeTicket} />
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}

export default WhatsappSupport;
